
import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";
import { getAuthToken } from "../../utils/token";
import config from "../../config/config";
import Loader from "../loader/Loader";
const MachineSetupModal = ({ show, handleClose, machineSetupId }) => {
  const [machinesetupwindow, setMachinesetupwindow] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const initialFormData = {
    selectedProductId: null,
    selectedDieId: null,
    dateOfSetup: "",
    notes: "",
    checklist: {
      temperature: false,
      dieSize: false,
      pressure: false,
      time: false,
      volume: false,
    },
  };
  const [formData, setFormData] = useState(initialFormData);
  useEffect(() => {
    if (show && machineSetupId) {
      setFormData(initialFormData);
      setErrors({});
      fetchMachinesetupwindow();
    }
  }, [show, machineSetupId]);
  const fetchMachinesetupwindow = async () => {
    setLoading(true);
    const token = getAuthToken();
    if (!token) return;
    try {
      const res = await axios.get(
        `${config.API}/manager/machinesetupwindow/${machineSetupId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );
      if (res.data.success) {
        setMachinesetupwindow(res.data.data);
      }
    } catch {
      toast.error("Failed to load machine setup data");
    } finally {
      setLoading(false);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleChecklistChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      checklist: { ...prev.checklist, [name]: checked },
    }));
  };

 const handleSave = async () => {
  setErrors({});
  setLoading(true);

  const token = getAuthToken();
  if (!token) {
    setLoading(false);
    return;
  }
  const payload = {
    machine_id: Number(machinesetupwindow?.machine?.id),
     product_id: formData.selectedProductId
    ? Number(formData.selectedProductId)
    : null,
  die_id: formData.selectedDieId
    ? Number(formData.selectedDieId)
    : null,
    machine_temperature:formData.checklist.temperature,
    die_size_enabled: formData.checklist.dieSize,
    injection_pressure:formData.checklist.pressure,
    injection_time:formData.checklist.time,
    injection_volume: formData.checklist.volume,
    setup_date: formData.dateOfSetup,
    notes: formData.notes,
    status: "saved",
  };

  try {
    const res = await axios.post(
      `${config.API}/manager/machinesetupwindow`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );
    if (res.data?.success === true) {
      toast.success(res.data.message || "Saved successfully");
      handleClose();
      return;
    }
    if (res.data?.success === false && res.data?.message) {
      setErrors(res.data.message);
      console.log(res.data.message)
      return;
    }

  } catch (err) {
    if (err.response?.data?.message) {
      setErrors(err.response.data.message);
    } else {
      toast.error("Server error");
    }
  } finally {
    setLoading(false);
  }
};


  if (loading || !machinesetupwindow) {
    return (
      <Modal show={show} centered>
        <Modal.Body className="text-center">
          <Loader /> Loading...
        </Modal.Body>
      </Modal>
    );
  }

  const productOptions =
    machinesetupwindow.product?.map((product) => ({
      value: product.id,
      label: product.name,
    })) || [];

  const dieOptions =
    machinesetupwindow.die?.map((die) => ({
      value: die.id,
      label: die.name,
    })) || [];

  console.log(errors,"errorserrorserrors")
  return (
    <Modal show={show} onHide={handleClose} centered  className="font_family">
      <Modal.Body>
        <h5 className="mb-3 fw-bold">Machine Setup Window</h5>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Machine</Form.Label>
            <div className="form-control">
              {machinesetupwindow.machine.machine_code}
            </div>
            {errors.machine_id && (
              <small className="text-danger">{errors.machine_id[0]}</small>
            )}
          </Form.Group>
          <div className="border p-3 mb-3">
            <Form.Check
              label="Machine Temperature"
              name="temperature"
              checked={formData.checklist.temperature}
              onChange={handleChecklistChange}
            />
            {errors.machine_temperature && (
              <small className="text-danger d-block">
                {errors.machine_temperature[0]}
              </small>
            )}
            <Form.Check
              label="Die Size"
              name="dieSize"
              checked={formData.checklist.dieSize}
              onChange={handleChecklistChange}
            />
            {errors.die_size_enabled && (
              <small className="text-danger d-block">
                {errors.die_size_enabled[0]}
              </small>
            )}
            <Form.Check
              label="Injection Pressure"
              name="pressure"
              checked={formData.checklist.pressure}
              onChange={handleChecklistChange}
            />
            {errors.injection_pressure && (
              <small className="text-danger d-block">
                {errors.injection_pressure[0]}
              </small>
            )}
            <Form.Check
              label="Injection Time"
              name="time"
              checked={formData.checklist.time}
              onChange={handleChecklistChange}
            />
            {errors.injection_time && (
              <small className="text-danger d-block">
                {errors.injection_time[0]}
              </small>
            )}
            <Form.Check
              label="Injection Volume"
              name="volume"
              checked={formData.checklist.volume}
              onChange={handleChecklistChange}
            />
            {errors.injection_volume && (
              <small className="text-danger d-block">
                {errors.injection_volume[0]}
              </small>
            )}
          </div>
          <Form.Group className="mb-3">
            <Form.Label>Product</Form.Label>
            <Select
              options={productOptions}
              value={productOptions.find(
                (product) => product.value === formData.selectedProductId
              )}
              onChange={(opt) =>
                setFormData((prev) => ({
                  ...prev,
                  selectedProductId: opt ? opt.value : null,
                }))
              }
            />
            {errors.product_id && (
              <small className="text-danger">{errors.product_id[0]}</small>
            )}
          </Form.Group>
          <Row className="mb-3">
            <Col>
              <Form.Label>Date of Setup</Form.Label>
              <Form.Control
                type="date"
                name="dateOfSetup"
                value={formData.dateOfSetup}
                onChange={handleChange}
              />
              {errors.setup_date && (
                <small className="text-danger">
                  {errors.setup_date[0]}
                </small>
              )}
            </Col>
            <Col>
              <Form.Label>Die</Form.Label>
              <Select
                options={dieOptions}
                value={dieOptions.find(
                  (die) => die.value === formData.selectedDieId
                )}
                onChange={(opt) =>
                  setFormData((prev) => ({
                    ...prev,
                    selectedDieId: opt ? opt.value : null,
                  }))
                }
              />
              {errors.die_id && (
                <small className="text-danger">{errors.die_id[0]}</small>
              )}
            </Col>
          </Row>
          <Form.Group className="mb-3">
            <Form.Label>Notes</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="notes"
              value={formData.notes}
              onChange={handleChange}
            />
            {errors.notes && (
              <small className="text-danger">{errors.notes[0]}</small>
            )}
          </Form.Group>
          <div className="d-flex justify-content-end">
            <Button variant="secondary" onClick={handleClose} className="me-2">
              Cancel
            </Button>
            <Button variant="dark" onClick={handleSave} disabled={loading}>
              Save
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default MachineSetupModal;
